import { OutsidePublic } from './outsidePublic';
import { AnimationManager } from './animation';
class JavascriptSearch {
    static resetSearch(noResultsElementShowId, singleElementWrapperSelector, singleElementContentToSearchSelector) {
        if (noResultsElementShowId.length > 0) {
            $('#' + noResultsElementShowId).hide();
        }
        $(singleElementWrapperSelector).find(singleElementContentToSearchSelector).each(function () {
            var html = $(this).html();
            var r = html.replace(/\<span class=\"search-highlight\"\>(.+?)\<\/span\>/g, "$1");
            $(this).html(r);
        });
    }
    static initializeJavascriptSearch(formId, buttonId, url, searchFieldId, singleElementWrapperSelector, singleElementContentToSearchSelector, noResultsElementShowId, scrollToAnchorElementId, defaultMinLength = 1, doHighlight = true) {
        let form = document.getElementById(formId);
        if (form) {
            form.addEventListener("submit", event => JavascriptSearch.onSubmitSearchForm(event, formId, url, searchFieldId, singleElementWrapperSelector, singleElementContentToSearchSelector, noResultsElementShowId, scrollToAnchorElementId, defaultMinLength, doHighlight));
            let searchField = document.getElementById(searchFieldId);
            if (searchField) {
                searchField.addEventListener("focusout", () => {
                    if ($('#' + searchFieldId).val() === '') {
                        JavascriptSearch.resetSearch('', singleElementWrapperSelector, singleElementContentToSearchSelector);
                        $(singleElementWrapperSelector).show(AnimationManager.getCurrentDuration());
                    }
                });
                if (buttonId.length === 0) {
                    searchField.addEventListener("keyup", (event) => JavascriptSearch.onSearchValueChanged(event, formId, url, searchFieldId, singleElementWrapperSelector, singleElementContentToSearchSelector, noResultsElementShowId, scrollToAnchorElementId, defaultMinLength, doHighlight));
                }
            }
        }
    }
    static searchClick(url, searchFieldId, singleElementWrapperSelector, singleElementContentToSearchSelector, noResultsElementShowId, scrollToAnchorElementId, defaultMinLength = 1, doHighlight = true) {
        let searchTextInputElement = $('#' + searchFieldId);
        let searchText = searchTextInputElement.val() ?? "";
        let minLength = parseInt(searchTextInputElement.attr('data-val-minlength-min') ?? "");
        if (!minLength) {
            minLength = defaultMinLength;
        }
        let form = $(FormUtils.getForm($('#' + searchFieldId)[0]));
        if (form.valid() && searchText.length >= minLength) {
            if (url.length > 0) {
                JavascriptSearch.pushSearchValue(url, searchText);
            }
            JavascriptSearch.resetSearch(noResultsElementShowId, singleElementWrapperSelector, singleElementContentToSearchSelector);
            JavascriptSearch.executeSearch(searchText, singleElementWrapperSelector, singleElementContentToSearchSelector, noResultsElementShowId, scrollToAnchorElementId, doHighlight);
        }
    }
    static pushSearchValue(url, searchValue) {
        var data = {
            SimpleValue: searchValue
        };
        OutsidePublic.executeAjaxCall(url, data, null, null, '');
    }
    static executeSearch(searchText, singleElementWrapperSelector, singleElementContentToSearchSelector, noResultsElementShowId, scrollToAnchorElementId, doHighlight = true) {
        var duration = AnimationManager.getCurrentDuration();
        if (searchText) {
            var matches = $(singleElementWrapperSelector + ":icontains('" + searchText + "')");
            $(singleElementWrapperSelector).hide();
            if (matches.length > 0) {
                matches.show(duration);
                if (doHighlight) {
                    matches.find(singleElementContentToSearchSelector).each(function () {
                        JavascriptSearch.highlightTextWithinElement($(this), searchText);
                    });
                }
            }
            else {
                if (noResultsElementShowId) {
                    $('#' + noResultsElementShowId).show();
                }
            }
        }
        else {
            let singleElementWrapper = $(singleElementWrapperSelector);
            if (singleElementWrapper) {
                singleElementWrapper.show(duration);
            }
        }
        OutsidePublic.scrollToAnchor(scrollToAnchorElementId);
    }
    static highlightTextWithinElement($element, searchText) {
        $element.contents().each(function () {
            if (this.nodeType === Node.TEXT_NODE) {
                const text = this.textContent || "";
                const replacedText = text.replace(new RegExp(searchText, "ig"), (match) => {
                    return `<span class="search-highlight">${match}</span>`;
                });
                const tempElement = document.createRange().createContextualFragment(replacedText);
                if (this.parentNode) {
                    this.parentNode.replaceChild(tempElement, this);
                }
            }
            else if (this instanceof HTMLElement) {
                JavascriptSearch.highlightTextWithinElement($(this), searchText);
            }
        });
    }
}
JavascriptSearch.onSubmitSearchForm = (e, formId, url, searchFieldId, singleElementWrapperSelector, singleElementContentToSearchSelector, noResultsElementShowId, scrollToAnchorElementId, defaultMinLength = 1, doHighlight = true) => {
    e.preventDefault();
    try {
        JavascriptSearch.searchClick(url, searchFieldId, singleElementWrapperSelector, singleElementContentToSearchSelector, noResultsElementShowId, scrollToAnchorElementId, defaultMinLength, doHighlight);
    }
    catch (exception) {
        if (exception instanceof Error) {
            console.log(exception.message);
        }
        else {
            console.log("An unknown error occurred", exception);
        }
    }
    return false;
};
JavascriptSearch.onSearchValueChanged = (event, formId, url, searchFieldId, singleElementWrapperSelector, singleElementContentToSearchSelector, noResultsElementShowId, scrollToAnchorElementId, defaultMinLength = 1, doHighlight = true) => {
    var doSearch = true;
    if (doSearch === true) {
        doSearch = false;
        window.setTimeout(() => { doSearch = true; }, 300);
        return JavascriptSearch.onSubmitSearchForm(event, formId, url, searchFieldId, singleElementWrapperSelector, singleElementContentToSearchSelector, noResultsElementShowId, scrollToAnchorElementId, defaultMinLength, doHighlight);
    }
};
window.JavascriptSearch = JavascriptSearch;
